import axios from 'axios'

import {guid} from "src/service/utils"
import {APP_WCRS_DEV, APP_WCRS_PROD} from "src/service/constant/url"


export const hostServer = () => {
    if (window.location.host.includes('dev') || window.location.host.includes('local') || window.location.host.includes('5.0.50')) {
        return APP_WCRS_DEV
    } else {
        return APP_WCRS_PROD
    }
}

export const httpData = <T>(CmdType: number, Body?: T) => {
    return JSON.stringify({
        Header: {
            CmdType,
            RequestID: guid()
        },
        Body
    })
}
export const axiosDefaultData = async <T>(CmdType: number, Body?: T) => {
    return await axios
        .post(hostServer(), httpData(CmdType, Body), {withCredentials: true})
        .then((response) => {
            const {Header, Body} = response.data
            return {Header, Body}
        })
        .catch((error) => {
            return error
        })
}